import { ca } from '@cian/analytics';
import { getTrackingProducts } from '../../../../utils/tracking';

export const trackShowMoreHouses = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click_sopr',
    label: 'HouseBuiltMore',
    products: getTrackingProducts(builderId),
  });
};
